import FullLogo from './fullLogo.png';

export const fullLogo = () => FullLogo;
